import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ClientComponent } from './client.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientAddEditComponent } from './client-add-edit/client-add-edit.component';
import { ClientSelectorComponent } from './client-selector/client-selector.component';
import { clientRouting } from './client.routing';
import { AuthGuard } from '@b4m/b4m-frontend-core';
import { CustomModalModule } from '../custom-modal/custom-modal.module';
import { Utils } from '../shared/utils';
import { SharedModule } from '../shared/shared.module';
import { DashheadModule } from '@app/dashhead/dashhead.module';

@NgModule({
  imports: [CommonModule,
    clientRouting,
    FormsModule,
    BrowserModule,
    TranslateModule,
    CustomModalModule,
    DashheadModule,
    SharedModule],
  declarations: [ClientComponent, ClientListComponent,
    ClientAddEditComponent, ClientSelectorComponent],
  exports: [ClientComponent, ClientSelectorComponent],
  providers: [AuthGuard, Utils]
})
export class ClientModule { }
